import { uniqueId } from 'lodash';
import React from 'react';

import { Select } from '@dndbeyond/character-components/es';
import { Ability, AbilityUtils, HelperUtils, HtmlSelectOption } from '@dndbeyond/character-rules-engine/es';

import { TypeScriptUtils } from '../../../Shared/utils';

const standardScores: Array<number> = [8, 10, 12, 13, 14, 15];

interface Props {
    abilities: Array<Ability>;
    onChange: (statId: number, value: number | null) => void;
}
export default class AbilityScoreManagerStandardArray extends React.PureComponent<Props> {
    handleChange = (statId: number, value: string): void => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(statId, HelperUtils.parseInputInt(value));
        }
    };

    render() {
        const { abilities } = this.props;

        const usedScores = abilities
            .map((abilityScore) => abilityScore.baseScore)
            .filter(TypeScriptUtils.isNotNullOrUndefined);

        return (
            <div className="ability-score-manager ability-score-manager-standard">
                <div className="ability-score-manager-stats">
                    {abilities.map((abilityScore) => {
                        const uId = uniqueId('qry_');
                        const availableScores = standardScores.reduce((acc: Array<number>, score) => {
                            if (!usedScores.includes(score) || score === abilityScore.baseScore) {
                                acc.push(score);
                            }

                            return acc;
                        }, []);
                        const availableScoreOptions: Array<HtmlSelectOption> = availableScores.map((score) => ({
                            label: '' + score,
                            value: score,
                        }));

                        return (
                            <div className="ability-score-manager-stat" key={abilityScore.id}>
                                <div className="builder-field form-select-field">
                                    <span className="builder-field-label">
                                        <label className="builder-field-heading form-select-field-label" htmlFor={uId}>
                                            {abilityScore.label}
                                        </label>
                                    </span>
                                    <span className="builder-field-input">
                                        <Select
                                            id={uId}
                                            options={availableScoreOptions}
                                            value={abilityScore.baseScore}
                                            onChange={this.handleChange.bind(this, abilityScore.id)}
                                            placeholder={'--'}
                                        />
                                    </span>
                                    <div className="ability-score-manager-stat-total">
                                        Total: {AbilityUtils.getTotalScore(abilityScore) ?? '--'}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
